import { useState } from 'react';
import { Button, Flex, Checkbox, Icon } from '@vibe/core';
import { Info } from '@vibe/icons';

type BetaOverlayProps = {
  onClose: () => void;
};

function BetaOverlay({ onClose }: BetaOverlayProps) {
  const [checkboxChecked, setCheckboxChecked] = useState(false);

  return (
    <div className="BetaOverlay">
      <div className="BetaOverlay-Modal">
        <Flex direction="column" gap="small" align="start">
          <Flex direction="row" gap="small" align="center">
            <Icon icon={Info} size={24} />
            <h2 style={{ fontSize: '20px' }}>Note about Supported Formats</h2>
          </Flex>
          <p style={{ marginTop: '0px', fontSize: '14px', lineHeight: '22px', textAlign: 'left' }}>
            From time to time, monday.com updates their Excel export structure. Since these changes occur without prior notice to
            developers, our team may require a transition period to adapt our converter to the new format. While we aim for 100%
            compatibility, significant structural changes by monday.com may impact our ability to fully support certain new formats.{' '}
            <a href="https://getgorilla.app/products/exported-excel-cleaner/docs/supported-formats" target="_blank">
              {' '}
              Read more
            </a>
          </p>
          <Flex direction="row" gap="medium" align="center" style={{ width: '100%' }}>
            <Checkbox
              defaultChecked
              id="checkbox"
              label="I understand that platform updates may require transition time."
              checked={checkboxChecked}
              onChange={() => {
                setCheckboxChecked((prev) => !prev);
              }}
            />
            <Button size="medium" kind="primary" onClick={onClose} disabled={!checkboxChecked} style={{ marginLeft: 'auto' }}>
              Confirm
            </Button>
          </Flex>
        </Flex>
      </div>
    </div>
  );
}

export default BetaOverlay;
